<template>
    <el-dialog
      width="500px"
      title="Edit Address"
      :show-close="false"
      top="1vh"
      :visible.sync="innerVisible"
      @close="innerClose"
      destroy-on-close
      :close-on-click-modal="false"
      >
      <div class="inside">
        <el-form label-position="top" :model="form" :rules="addressRules" ref="addressInnerForm">
          <el-row>
            <el-col :span="11">
              <el-form-item label="First Name" prop="name">
                  <el-input v-model="form.name" oninput="if(value.length>50)value=value.slice(0,50)"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="11" :offset="1">
              <el-form-item label="Last Name" prop="lastname">
                  <el-input v-model="form.lastname" oninput="if(value.length>50)value=value.slice(0,50)"></el-input>
                </el-form-item>
            </el-col>
          </el-row>
          <el-form-item
            class="form_content"
            label="Phone" prop="phone"
            :rules="{
              validator: checkPhone,
              trigger: 'change',
              required: true
            }"
          >
            <el-select
            style="width:200px"
              v-model="form.areaCode"
              filterable
              clearable
              placeholder="+ Country Code"
            >
              <el-option
                v-for="(item, index) in options"
                :label="item.value"
                :value="item.value"
                :key="index"
              >
                <span style="float: left">{{ item.text }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{
                  item.value
                }}</span>
              </el-option>
            </el-select>
            <el-input
              v-model="form.phone"
              placeholder="Phone"
              style="width: 140%"
              onkeyup="value=value.replace(/[^\d]/g,'')"
            ></el-input>
          </el-form-item>
          <el-row>
              <el-col :span="24">
              <el-form-item label="Address" prop="address">
                  <el-input type="textarea" placeholder="Street and Number" rows="5" v-model="form.address" maxlength="200"
                  onkeyup="value=value.replace(/[^\x00-\xff]/g, '')"
                  ></el-input>
                </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="City" prop="city">
                  <el-input v-model="form.city"
                  maxlength="40"
                  @input="changeCity"
                  ></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="11" :offset="1">
              <el-form-item label="State" prop="province">
                  <el-input v-model="form.province"
                  maxlength="40"
                  @input="changeProvince"
                    ></el-input>
                </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="Country" prop="country" class="form_content">
                  <el-select
                    style="width:100%"
                    v-model="form.countryName"
                    filterable
                    clearable
                    placeholder="Enter Country"
                >
                  <el-option
                    v-for="(item, index) in options"
                    :label="item.text"
                    :value="item.text"
                    :key="index"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="1">
              <el-form-item label="Zipcode" prop="postCode">
                  <el-input  v-model="form.postCode"
                  oninput="if(value.length>5)value=value.slice(0,5)"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  ></el-input>
                </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="inside-footer">
        <span slot="footer" class="dialog-footer" center>
          <el-button type="primary" class="inside-footer-button" @click="addressSubmit">Submit</el-button>
          <el-button @click="innerVisible = false" class="inside-footer-button">Cancel</el-button>
        </span>
      </div>
      </div>
    </el-dialog>
</template>

<script>
import { postAction, getAction } from '@/api/manage.js'
export default {
  name: 'addressInner',
  props: {
    getAddressList: {
      type: Function,
      default: () => {}
    },
    addressMessage: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      options: [],
      innerVisible: false,
      form: {
        country: 'US',
        countryName: 'United States of America',
        name: '',
        lastname: '',
        areaCode: '+1(US)'
      },
      addressRules: {
        name: [
          { required: true, message: 'Please enter first name', trigger: 'blur' }
        ],
        lastname: [
          { required: true, message: 'Please enter last name', trigger: 'blur' }
        ],
        address: [
          { required: true, message: 'please enter address', trigger: 'blur' }
        ],
        countryName: [
          { required: true, message: 'Please enter country', trigger: 'blur' }
        ],
        province: [
          { required: true, message: 'Please fill in the Province', trigger: 'blur' }
        ],
        city: [
          { required: true, message: 'Please enter province', trigger: 'blur' }
        ],
        postCode: [
          { required: true, message: 'Please enter zipcode', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getPhoneAndCountry()
  },
  methods: {
    // 获取国家、手机号配置信息
    getPhoneAndCountry() {
      getAction('/sys/dict/getDictItems/reg-country-config').then(response => {
        if (response.success) {
          if (response.result) {
            this.options = response.result
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    addressSubmit() {
      this.$refs['addressInnerForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.form.userId = this.addressMessage.userId
        postAction('/order/address', this.form).then((res) => {
          if (res.success) {
            this.form.areaCode = '+1(US)'
            this.form.country = 'US'
            this.form.countryName = 'United States of America'
            this.$message.success(res.message)
            this.innerVisible = false
            this.$refs['addressInnerForm'].resetFields()
            this.getAddressList()
          } else {
            this.$message.error(res.message)
          }
        })
      })
    },
    innerClose() {
      this.form.areaCode = '+1(US)'
      this.form.country = 'US'
      this.form.countryName = 'United States of America'
      // 执行调用层打开弹窗方法
      this.$parent.$parent.openAddress()
    },
    changeProvince(value) {
      this.form.province = value
        .replace(/[\u4e00-\u9fa5]/g, '')
        .replace(/[\d]/g, '')
        .replace(
          /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g,
          ''
        )
    },
    changeCity(value) {
      this.form.city = value
        .replace(/[\u4e00-\u9fa5]/g, '')
        .replace(/[\d]/g, '')
        .replace(
          /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g,
          ''
        )
    },
    checkPhone(rule, value, callback) {
      let phone = this.form.phone
      let code = this.form.areaCode
      if (code == '') {
        callback(new Error('Please enter the countryCode'))
      }
      if (phone == '') {
        callback(new Error('Please enter the phone'))
      }
      if (code.indexOf('+1(US)') > -1 || code.indexOf('+44(UK)') > -1 || code.indexOf('+1(CA)') > -1) {
        if (phone.length !== 10) {
          callback(new Error('Please enter the correct number'))
        }
      }
      if (code.indexOf('+61(AU)') > -1) {
        if (phone.length !== 9) {
          callback(new Error('Please enter the correct number'))
        }
      }
      callback()
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .form_content .el-form-item__content{
  width: 100%!important;
  display: flex;
}
/deep/ .form_content .el-select .el-input__inner{
  margin-left: 0;
}
/deep/ .el-dialog{
  padding:23px 20px 27px 20px;
}
.inside{
  padding-top: 34px;
  .inside-footer{
  padding-top: 16px;
  display: flex;
  justify-content: center;
  .inside-footer-button{
    width: 142px;
    height: 40px;
  }
}
}
</style>



// WEBPACK FOOTER //
// src/pages/components/address-inner.vue